<template>
  <div class="search-form">
  </div>
</template>
<script>
const initForm = {
  queryType: 'A',
}

export default {
  data() {
    return {
      form: { ...initForm },
    }
  },
  watch: {
    'form.queryType'() {
      this.query()
    },
  },
  methods: {
    //初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reload')
      }
      this.$emit('query', this.form)
    },
  },
}
</script>
